import React, { Component } from 'react';
import PopupContainer from '../../../components/PopupContainer';
import Popup from '../../../components/SimplePopup';
import { withRouter } from 'react-router-dom';
import { API } from '../../../requests';

import ViewRenderer from './views';
import Spinner from '../../../components/Spinner';
import { commonImages } from '../../../assets/images';
import strings from '../../../globalization';
import { connect } from 'react-redux';
import TextInput from '../../../components/TextInput';
import Button from '../../../components/Button';
import modalStyles from './RefundIdModal.module.scss';

const POPUP_CONSTANTS = {
  STANDARD: 'standard',
  SIMPLE_POPUP: 'simple',
  ERROR: 'error',
  SPINNER_POPUP: 'spinner',
  DETAILS_POPUP: 'details',
};

const getBadgeClass = status => {
  const s = (status || '').toString().toLowerCase();
  if (s.includes('fail') || s.includes('rejected')) return modalStyles.badgeFailed;
  if (s.includes('success') || s.includes('completed') || s.includes('approved'))
    return modalStyles.badgeSuccess;
  if (s.includes('pending')) return modalStyles.badgePending;
  return modalStyles.badgePending;
};

const DetailItem = ({ label, value, isBadge = false }) => (
  <div className={modalStyles.detailItem}>
    <div className={modalStyles.label}>{label}</div>
    {isBadge ? (
      <div className={[modalStyles.badge, getBadgeClass(value)].join(' ')}>
        {(value || '—').toString()}
      </div>
    ) : (
      <div className={modalStyles.value}>{value || '—'}</div>
    )}
  </div>
);

class PersonVehicleTransactions extends Component {
  constructor(props) {
    super(props);
    const { reduxProps } = this.props;
    const {
      login: { loginInfo },
    } = reduxProps;
    const { user } = loginInfo;

    this.state = {
      selectedSearchKey: 'paymentId',
      selectedType: 'person',
      searchText: '',
      transactions: [],
      popup: undefined,
      user,
      refundIdInput: '',
    };
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen(() => {
      this.setState({
        popup: undefined,
      });
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentDidMount() {
    this.setState({
      popup: undefined,
    });
    this.getData();
  }

  getData = () => {
    const { selectedType, selectedSearchKey, searchText } = this.state;
    const searchId = (searchText || '').toString().trim();

    if (!searchId) {
      this.setState({ transactions: [] });
      this.showErrorPopup('Please enter search id before fetching.');
      return;
    }

    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });

    API.fetchPersonVehicleTransactions({
      type: selectedType,
      searchType: selectedSearchKey,
      searchId,
    })
      .then(res => {
        console.log('res.data', res.data);
        const transactions =
          res.data?.transactions ||
          res.data?.content ||
          (Array.isArray(res.data) ? res.data : []);

        this.setState({
          transactions,
          popup: undefined,
        });
      })
      .catch(error => {
        console.log('error fetching transactions', error);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        this.setState({
          popup: undefined,
        });
        this.showErrorPopup(
          errorMsg ||
          'There was an error while fetching the transactions, please try again after some time.',
        );
      });
  };

  showErrorPopup = errorMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMessage,
        messageStyle: { color: '#E67717' },
        headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  showSuccessPopup = successMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        headingImage: commonImages.successIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  onChangeHandler = (action, data) => {
    switch (action) {
      case 'onSearchKeyChange': {
        this.setState({
          selectedSearchKey: data,
        });
        break;
      }

      case 'onTypeChange': {
        this.setState({
          selectedType: data,
        });
        break;
      }

      case 'search': {
        this.setState({
          searchText: data,
        });
        break;
      }

      case 'refundId': {
        this.setState({
          refundIdInput: (data || '').toString().slice(0, 50),
        });
        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'fetchTransactions': {
        this.getData();
        break;
      }

      case 'rowClick': {
        this.setState({
          refundIdInput: (data?.refundId || '').toString().slice(0, 50),
          popup: {
            type: POPUP_CONSTANTS.DETAILS_POPUP,
            row: data,
          },
        });
        break;
      }

      case 'saveRefundId': {
        this.saveRefundId();
        break;
      }

      case 'clearFilters': {
        this.resetData();
        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  saveRefundId = () => {
    const { popup, refundIdInput, transactions } = this.state;
    const row = popup?.row;
    const refundId = (refundIdInput || '').toString().trim();

    if (!row) {
      this.closePopup();
      return;
    }

    if (!refundId) {
      this.showErrorPopup('Refund ID is required.');
      return;
    }

    API.updateRefundIdPersonVehicle({ orderId: row.orderId, refundId })
      .then(() => {
        const updated = (transactions || []).map(t =>
          t?.orderId && row?.orderId && t.orderId === row.orderId
            ? { ...t, refundId }
            : t,
        );

        this.setState(
          {
            transactions: updated,
            popup: undefined,
            refundIdInput: '',
          },
          () => this.showSuccessPopup('Refund ID saved.'),
        );
      })
      .catch(error => {
        const errorMsg =
          error?.response?.data?.message ||
          error?.message ||
          'Failed to save Refund ID. Please try again.';
        this.showErrorPopup(errorMsg);
      });
  };

  resetData = () => {
    this.setState({
      searchText: '',
      selectedSearchKey: 'paymentId',
      selectedType: 'person',
      transactions: [],
    });
  };

  closePopup = () => {
    this.setState({
      popup: undefined,
    });
  };

  getProps = () => {
    const { user, selectedSearchKey, selectedType, searchText, transactions } =
      this.state;
    return {
      onClick: this.onClickHandler,
      onChange: this.onChangeHandler,
      selectedSearchKey,
      selectedType,
      searchText,
      transactions,
      roleId: user.roleId,
    };
  };

  getPopupContent = () => {
    const { popup } = this.state;
    if (!popup) return;
    switch (popup.type) {
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.DETAILS_POPUP: {
        const row = popup.row || {};
        const { refundIdInput, selectedType } = this.state;

        const formatAmount = amount => {
          if (amount === null || amount === undefined || amount === '') return '—';
          const num = Number(amount);
          if (Number.isFinite(num)) return `₹${num.toFixed(2)}`;
          return amount;
        };

        const formatDate = dateString => {
          if (!dateString) return '—';
          try {
            return new Date(dateString).toLocaleDateString('en-IN');
          } catch (e) {
            return dateString;
          }
        };

        const orderDate = row.orderDate || row.createdDate || row.createdAt;
        const agencyName = row.companyName || row.agencyName || row.company || row.agency;

        return (
          <div className={modalStyles.modal}>
            <div className={modalStyles.header}>
              <div className={modalStyles.title}>Transaction Details</div>
              <button
                className={modalStyles.closeBtn}
                onClick={this.closePopup}
                aria-label="Close"
                type="button"
              >
                ×
              </button>
            </div>

            <div className={modalStyles.content}>
              <div className={modalStyles.detailsGrid}>
                <DetailItem label="Order ID" value={row.orderId} />
                <DetailItem label="Order Date" value={formatDate(orderDate)} />
                <DetailItem label="Payment ID" value={row.paymentId} />
                <DetailItem label="Amount" value={formatAmount(row.amount)} />
                <DetailItem
                  label={
                    selectedType === 'vehicle'
                      ? 'Vehicle Reference ID'
                      : 'Person Reference ID'
                  }
                  value={row.referenceId}
                />
                <DetailItem
                  label="Sanya Application Status"
                  value={row.status}
                  isBadge={true}
                />
                <DetailItem
                  label="Razorpay Status"
                  value={row.razorpayStatus}
                  isBadge={true}
                />
                <DetailItem label="Refund ID" value={row.refundId} />
              </div>

              <div className={modalStyles.sectionDivider} />

              <div className={modalStyles.refundRow}>
                <div className={modalStyles.inputWrap}>
                  <TextInput
                    label="Enter Refund ID"
                    placeholder="Enter Refund ID"
                    value={(refundIdInput || '').slice(0, 50)}
                    onChange={value => this.onChangeHandler('refundId', value)}
                    isEdit={true}
                  />
                </div>
              </div>
            </div>

            <div className={modalStyles.actions}>
              <Button
                buttonStyle="primary"
                label="Save Refund ID"
                className={modalStyles.saveButton}
                disabled={!!row.refundId || row.status === 'COMPLETED'}
                onClick={() => this.onClickHandler('saveRefundId')}
              />
            </div>
          </div>
        );
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };

  render() {
    const viewProps = this.getProps();
    const { popup } = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PersonVehicleTransactions),
);

